import urljoin from 'url-join';
import { portalApi } from './index.api';

const DISCOVERY = "smartPanels";
const PROJECTS = "projects";

export const projectsApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		projects: builder.query({
			query: () => ({
				// baseQueryWithAuth handles authorization header automatically
				url: PROJECTS,
				method: 'GET',
			}),
			providesTags: ['projects']
		}),
		projectId: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, projectId),
				method: 'GET',
			})
		}),
		projectCode: builder.query({
			query: (projectCode) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, "projectCode", projectCode),
				method: 'GET',
			})
		}),
		projectRecognizeRevenue: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, "recognize-revenue", projectId),
				method: 'POST',
				body: { projectId }
			})
		}),

		empty: builder.query({
			query: (projectId) => {
				if (!projectId) {
					throw new Error('projectId is required');
				}
				return {
					// baseQueryWithAuth handles authorization header automatically
					url: urljoin(PROJECTS, "empty", projectId),
					method: 'GET',
				};
			}
		}),
	})
});
/* 
√ GET /api/v1/projects
√ GET /api/v1/projects/{projectId}
√ GET /api/v1/projects/projectCode/{projectCode}
√ GET /api/v1/projects/empty/{projectId}
√ POST /api/v1/projects/recognize-revenue/{projectId}
 */
export const {
	useProjectsQuery,
	useEmptyQuery,
	useProjectCodeQuery,
	useProjectIdQuery,
	useProjectRecognizeRevenueQuery
} = projectsApi;
